import React, { useState } from 'react';
import { Layout, Space, Button, Typography, Dropdown } from 'antd';
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  DownOutlined,
  MenuOutlined
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import UserSettingsModal from './UserSettingsModal';

const { Header } = Layout;
const { Text } = Typography;

interface AppHeaderProps {
  collapsed: boolean;
  onToggleSidebar: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ collapsed, onToggleSidebar }) => {
  const { user, logout } = useAuth();
  const [userSettingsVisible, setUserSettingsVisible] = useState(false);

  const handleUserUpdate = (updatedUser: any) => {
    const currentUserData = JSON.parse(localStorage.getItem('user') || '{}');
    const newUserData = { ...currentUserData, ...updatedUser };
    localStorage.setItem('user', JSON.stringify(newUserData));
    window.location.reload();
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '用户设置',
      onClick: () => setUserSettingsVisible(true)
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: logout,
      danger: true
    }
  ];

  return (
    <>
      <Header className="app-header">
        <div className="app-header-leading">
          <Button
            className="app-header-menu"
            type="text"
            icon={<MenuOutlined />}
            aria-label={collapsed ? '展开导航菜单' : '收起导航菜单'}
            onClick={onToggleSidebar}
          />
        </div>
        {/* 用户信息和用户设置都归到右侧：左上角紧挨着侧边栏品牌区，
            两块内容贴在一起看着像是侧边栏的一部分。 */}
        <Space className="app-header-trailing" size={12}>
          <Text className="app-header-welcome">
            欢迎回来，<strong>{user?.username}</strong>
          </Text>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
            <Button className="app-header-user" type="text" icon={<UserOutlined />}>
              <Space>
                {user?.username}
                <DownOutlined style={{ fontSize: 12 }} />
              </Space>
            </Button>
          </Dropdown>
        </Space>
      </Header>

      <UserSettingsModal
        visible={userSettingsVisible}
        onCancel={() => setUserSettingsVisible(false)}
        user={user}
        onUserUpdate={handleUserUpdate}
      />
    </>
  );
};

export default AppHeader;
